// extracted by mini-css-extract-plugin
export default {"card":"VehicleCard_card__QXZWY"};